import type { EntryType, LogEntry } from '../types'

export type TimeBucket = 'morning' | 'lunch' | 'afternoon' | 'evening' | 'night'

const BUCKET_ORDER: TimeBucket[] = ['morning', 'lunch', 'afternoon', 'evening', 'night']

export function getTimeBucket(date: Date): TimeBucket {
  const hour = date.getHours()
  if (hour >= 6 && hour < 11) return 'morning'
  if (hour >= 11 && hour < 14) return 'lunch'
  if (hour >= 14 && hour < 17) return 'afternoon'
  if (hour >= 17 && hour < 22) return 'evening'
  return 'night'
}

export function buildCategoryCounts(logs: LogEntry[], since: Date) {
  const result: Record<EntryType, Record<string, Record<TimeBucket, number>>> = {
    did: {},
    ate: {},
    drank: {},
    other: {},
  }

  for (const log of logs) {
    const timestamp = new Date(log.date)
    if (Number.isNaN(timestamp.getTime()) || timestamp < since) {
      continue
    }
    const bucket = getTimeBucket(timestamp)
    const typeCounts = result[log.type]
    if (!typeCounts[log.category]) {
      typeCounts[log.category] = Object.fromEntries(BUCKET_ORDER.map(key => [key, 0])) as Record<TimeBucket, number>
    }
    typeCounts[log.category][bucket] += 1
  }

  return result
}
